import { OmniaCommandGroup } from "../shared/components/omniaCommandGroup";
import { setupPagination } from "../shared/components/pagination";
import { PopupMenuCtrl } from "../shared/components/popupMenu/popupMenu";
import { setupSlider } from "../shared/components/slider";
import { TableHeaderSyncMgr } from "../shared/components/tableHeaderSync";

export const components = {
    OmniaCommandGroup,
    PopupMenuCtrl,
    TableHeaderSyncMgr,
    setupSlider,
    setupPagination
}